import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import HomeNew from "./pages/HomeNew";
import HomeModern from "./pages/HomeModern";
import QuemSomos from "./pages/QuemSomos";
import Funeral from "./pages/Funeral";
import FuneralValor from "./pages/FuneralValor";
import Cremacao from "./pages/Cremacao";
import Translado from "./pages/Translado";
import Contato from "./pages/Contato";
import FunerariaMeier from "./pages/FunerariaMeier";
import FunerariaNoMeier from "./pages/FunerariaNoMeier";
import FunerariaNaTijuca from "./pages/FunerariaNaTijuca";
import FunerariaNoCentro from "./pages/FunerariaNoCentro";
import FunerariaBarraDaTijuca from "./pages/FunerariaBarraDaTijuca";
import FunerariaEmBotafogo from "./pages/FunerariaEmBotafogo";
import FunerariaBairrosRJ from "./pages/FunerariaBairrosRJ";
import ValorFuneralRJ from "./pages/ValorFuneralRJ";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow pt-20">
          <Routes>
            <Route path="/" element={<HomeNew />} />
            <Route path="/funeraria-rj" element={<HomeNew />} />
            <Route path="/funeraria-24horas" element={<HomeNew />} />
            <Route path="/home" element={<HomeModern />} />
            <Route path="/home-old" element={<Home />} />
            <Route path="/quem-somos" element={<QuemSomos />} />
            <Route path="/funeral" element={<FuneralValor />} />
            <Route path="/funeral-old" element={<Funeral />} />
            <Route path="/cremacao" element={<Cremacao />} />
            <Route path="/translado" element={<Translado />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/funeraria-meier" element={<FunerariaMeier />} />
            <Route path="/funeraria-no-meier" element={<FunerariaNoMeier />} />
            <Route path="/funeraria-na-tijuca" element={<FunerariaNaTijuca />} />
            <Route path="/funeraria-no-centro" element={<FunerariaNoCentro />} />
            <Route path="/funeraria-barra-da-tijuca" element={<FunerariaBarraDaTijuca />} />
            <Route path="/funeraria-em-botafogo" element={<FunerariaEmBotafogo />} />
            <Route path="/funeraria-zona-norte-zona-sul" element={<FunerariaBairrosRJ />} />
            <Route path="/valor-funeral-rj" element={<ValorFuneralRJ />} />
            <Route path="/atuacao" element={<FunerariaNoMeier />} />
            <Route path="/publicacoes" element={<HomeModern />} />
            <Route path="/servicos/*" element={<FunerariaNoMeier />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
